/* eslint-disable max-classes-per-file */
import React from 'react';
import { Input, Form, Popover } from 'antd';
import RichText from '../../component/rich-text';
import FormImage from '../../component/upload-image';
import { article } from '../../services/intschool';
import ItemListContainer from './component/item_list_container';
import QrCode from '../../component/qrcode';
import Time from '../../component/time';
import { appConfig } from '../../common/config';

const { Item } = Form;

function ArticleForm({ disabled }) {
  return (
    <>
      <Item label="封面" name="coverUrl" rules={[{ required: true, whitespace: true, message: '请选择文章封面' }]}>
        <FormImage disabled={disabled} preset="common-image" max={1} />
      </Item>
      <Item label="标题" name="title" rules={[{ required: true, whitespace: true, message: '请输入文章标题' }]}>
        <Input disabled={disabled} />
      </Item>
      <Item
        label="正文"
        name="content"
        rules={[
          {
            required: true,
            validator: (rule, value) =>
              // eslint-disable-next-line prefer-promise-reject-errors
              RichText.isEmpty(value) ? Promise.reject('请输入文章正文') : Promise.resolve(),
          },
        ]}
      >
        <RichText disabled={disabled} />
      </Item>
    </>
  );
}
export default function ArticleList({
  match: {
    params: { id },
  },
}) {
  return (
    <ItemListContainer
      name="文章"
      columns={[
        {
          title: '标题',
          key: 'title',
          compare: true,
          render: (value, { id, isReviewData, pvcode = '' }) => {
            if (!isReviewData) {
              return value;
            }
            return (
              <Popover
                trigger="click"
                content={
                  <div style={{ textAlign: 'center' }}>
                    <span>手机扫码查看页面</span>
                    <QrCode text={`${appConfig.frontend}/international-school/article/${id}?previewCode=${pvcode}`} />
                  </div>
                }
              >
                <span className="color-blue6">{value}</span>
              </Popover>
            );
          },
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: '120px',
          render: createTime => <Time time={createTime} />,
        },
      ]}
      api={article}
      intSchoolId={id}
      form={ArticleForm}
      wideModal
      hideOrder
      itemDeleteText="删除该文章后，相应动态也会被删除，是否仍然删除？"
      itemEnableConfirmText="上线该文章时，同时会发送一篇动态，确定要上线吗？"
      itemDisableConfirmText="下线该文章时，同时删除关联的动态，确定要下线吗？"
    />
  );
}
